import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AppConfig } from './../../app.config';
@Injectable()
export class ForgotPasswdService {
  private urlPasswordRequest: string;

  constructor(private _http: HttpClient, private _appConfig: AppConfig) {
    this.urlPasswordRequest = _appConfig.getConfig().nPointAuthService + '/auth/pwd_requestreset';
  }

  passwordRequest(p_Login: string) {
    const l_Data = { platform: 25, login: p_Login, urlMask: this._appConfig.getConfig().urlPasswordReset, origin: 2};

    return this._http.post(this.urlPasswordRequest, l_Data);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/login/forgot-passwd.service.ts